import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ExportsApi } from '@ulysses-inc/harami_api_client'
import { queryKeys } from 'src/features/reportExport/list/api/queryKeys'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'

export type AddBulkReportExportParams = {
  fileName: string
  filterCondition: {
    templateIds: number[]
    placeNodeUuidList: string[]
    startDateTime: Date
    endDateTime: Date
  }
}

/**
 * `POST /reports/exports/bulk` を呼ぶ mutation。 エラー通知は呼び出し側の `onError` で制御する。
 */
export const useMutationAddBulkReportExport = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (params: AddBulkReportExportParams) => {
      return await baseClient
        .getApi(ExportsApi)
        .addBulkReportsExports({
          postReportsExportsBulkRequestBody: {
            fileName: params.fileName,
            filterCondition: {
              templateIds: params.filterCondition.templateIds,
              placeNodeUuidList: params.filterCondition.placeNodeUuidList,
              startDateTime: params.filterCondition.startDateTime,
              endDateTime: params.filterCondition.endDateTime,
            },
          },
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.all })
    },
  })
}
